import { StorageManager } from "../base/port/StorageManager";
export class LocalStorageManagerImpl extends StorageManager {
    clear() {
        return localStorage.clear();
    }
    getItem(key) {
        return localStorage.getItem(key) ?? undefined;
    }
    removeItem(key) {
        return localStorage.removeItem(key);
    }
    setItem(key, value) {
        return localStorage.setItem(key, value);
    }
}
